export default "__VITE_ASSET__1fcd0008__"